<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="ifShow"
      width="800px"
      @close="$emit('closeDialog', false)"
    >
      <section class="recommendLog-wrap">
        <div class="recommendLog-header">
          <el-form
            ref="recommendLogForm"
            :model="recommendData"
            label-position="right"
            label-width="7rem"
          >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="公司名称" prop="companyName">
                  <el-input v-model="recommendData.companyName" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="联系人姓名" prop="relationName">
                  <el-input v-model="recommendData.relationName" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <div class="recommendLog-query" @click="getrecommendClick(recommendData)"><i class="iconfont iconsousuo" />查询</div>
                <div class="recommendLog-reset" @click="recommendReset('recommendLogForm')"><i class="iconfont iconzhongzhi" />重置</div>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!--表格头部-->
        <article class="recommendLog-title">
          <ul>
            <li>
              <el-checkbox v-model="allSelectionRecommend" @change="selectionRecommend()" />
            </li>
            <li>公司名称</li>
            <li>公司地址</li>
            <li>联系人</li>
            <li>性别</li>
            <li>联系电话</li>
          </ul>
        </article>
        <!--表格内容-->
        <article class="recommendLog-body">
          <template v-for="(item,itemIndex) in RecommendData">
            <div :key="itemIndex" class="body-item">
              <ul>
                <li>
                  <el-checkbox v-model="item.selection" @change="recommendChange()" />
                </li>
                <li>{{ item.companyName }}</li>
                <li>{{ item.companyAddress }}</li>
                <li>{{ item.relationName }}</li>
                <li>{{ item.relationSex }}</li>
                <li>{{ item.relationPhone }}</li>
              </ul>
            </div>
          </template>
        </article>
        <div class="recommendLog-body-btn" @click="recommendedSubClick()">推荐</div>
      </section>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import * as get from '@/api/personal/customer/contacts/index.js' // 请求接口
export default {
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '推荐联系人'
    },
    popData: {
      type: [Object, String, Array],
      default: ''
    },
    recommendId: {
      type: [Object, String, Array],
      default: ''
    }
  },
  data() {
    return {
      ifShow: this.dialogShow,
      // 推荐联系人全选
      allSelectionRecommend: false,
      // 推荐联系人form搜索
      recommendData: {
        companyName: '', // 公司名称
        relationName: '', // 联系人名称
        id: this.recommendId
      },
      // 推荐联系人数据
      RecommendData: this.popData
    }
  },
  created() {
    this.apilist()
  },
  methods: {
    // 获取列表
    apilist() {
      get.recommendList({
        id: this.recommendId,
        delFlag: '5'
      }).then(res => {
        console.log(res)
        this.RecommendData = res.result
        // 清空选中状态
        // this.allSelectionRecommend = false
        // this.RecommendData = res.result.map(ele => {
        //   ele.selection = false
        //   return ele
        // })
      }).catch(error => {
        console.log(error)
      })
    },
    // 推荐-查询按钮
    getrecommendClick(data) {
      for (const i in data) {
        data[i] = data[i].replace(/\s+/g, '')
      }
      const odata = {
        id: this.recommendId
      }
      get.queryrecommendList(data, odata).then(res => {
        this.RecommendData = res.result
      }).catch(error => {
        console.log(error)
      })
    },
    // 推荐联系人重置
    recommendReset(ref) {
      this.$refs[ref].resetFields()
      this.getrecommendClick(this.recommendData)
    },
    // 推荐联系人 子项多选
    recommendChange() {
      this.allSelectionRecommend = this.RecommendData.every(i => i.selection)
    },
    // 推荐联系人全选
    selectionRecommend() {
      this.RecommendData.forEach(i => {
        if (i.selection !== this.allSelectionRecommend) {
          i.selection = !i.selection
        }
      })
    },
    // 推荐-提交
    recommendedSubClick() {
      const ids = this.RecommendData.filter(item => item.selection).map(item => item.id)
      const idString = ids.join(',')
      if (ids.length > 0) {
        get.recommendedSub({
          recommendId: this.recommendId,
          recommendedId: idString
        }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: '推荐成功',
              type: 'success'
            })
            this.recommendShow = false
            // 提交后清空选中状态
            this.allSelectionRecommend = false
            this.RecommendData = this.RecommendData.map(ele => {
              ele.selection = false
              return ele
            })
            // 执行父级刷新  和关闭弹窗
            this.$emit('closeDialog')
          }
        }).catch(error => {
          console.log(error)
        })
      } else {
        this.$message({
          type: 'warning',
          message: '请选择推荐项!'
        })
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  $main-color: #be2316;
  /*推荐联系人*/
  .recommendLog-wrap{
    .recommendLog-header{
      .recommendLog-query{
        width: 68px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        background: #BE2316;
        color: #fff;
        font-size: 14px;
        border-radius: 4px;
        float: left;
        cursor: pointer;
        margin-right: 10px;
      }
      .recommendLog-reset{
        width: 68px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        background: #fff;
        color: #BE2316;
        font-size: 14px;
        float: left;
        cursor: pointer;
        border: 1px solid #BF2316;
        border-radius: 4px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
      }
    }
    .recommendLog-title {
      color: $main-color;
      font-weight: bold;
      width: 100%;
      height: 51px;
      background: #EEEFF1;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
      border-radius: 4px;
      margin-top: 10px;
      ul {
        display: flex;
        flex-wrap: nowrap;
        line-height: 51px;
        box-sizing: content-box;
        li {
          font-size: 14px;
          min-width: 50px;
          margin: auto auto;
          text-align: center;
          color: #BE2316;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          &:first-child {
            flex-basis: 5%;
          }
          &:nth-child(2) {
            flex-basis: 20%;
          }
          &:nth-child(3) {
            flex-basis: 20%;
          }
          &:nth-child(4) {
            flex-basis: 15%;
          }
          &:nth-child(5) {
            flex-basis: 15%;
          }
          &:nth-child(6) {
            flex-basis: 20%;
          }
        }
      }
    }
    .recommendLog-body {
      position: relative;
      height: 420px;
      overflow: auto;
      .body-item {
        width: 100%;
        height: auto;
        background: rgba(255, 255, 255, 1);
        border-bottom:1px solid rgba(166,166,166,0.3);
        position: relative;
        box-sizing: border-box;
        ul {
          display: flex;
          flex-wrap: nowrap;
          line-height: 51px;
          box-sizing: content-box;
          /**::selection {*/
          /*background-color: rgba(0, 0, 0, 0) !important;*/
          /*}*/
          li {
            font-size: 14px;
            min-width: 50px;
            margin: auto auto;
            text-align: center;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            &:first-child {
              flex-basis: 5%;
            }
            &:nth-child(2) {
              flex-basis: 20%;
              color: #333;
            }
            &:nth-child(3) {
              flex-basis: 20%;
              color: #333;
            }
            &:nth-child(4) {
              flex-basis: 15%;
              color: #555;
            }
            &:nth-child(5) {
              flex-basis: 15%;
            }
            &:nth-child(6) {
              flex-basis: 20%;
            }
          }
        }
        /deep/ .goods-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .recommendLog-body-btn{
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 18px;
      border-radius: 4px;
      background: #BE2316;
      color: #fff;
      margin: 0 auto;
      margin-top: 30px;
      cursor: pointer;
    }
  }
</style>
